<template>
  <!-- Floating Contact Us Button -->
  <div v-if="!isAuthenticated">
    <a
      href="mailto:help@ipacconsulting.com"
      class="contact-us-button"
      aria-label="Contact Us"
    >
      <div class="d-flex align-items-center gap-2">
        <i class="fi fi-support"></i>
        <span class="link-label">Contact Us</span>
      </div>
    </a>
  </div>
  
  <!-- For authenticated users, show button that opens email form -->
  <div v-else class="contact-us-logged-in-container">
    <a
      @click.prevent="showEmailForm"
      href="#"
      class="contact-us-button"
      aria-label="Contact Us"
    >
      <div class="d-flex align-items-center gap-2">
        <i class="fi fi-support"></i>
        <span class="link-label">Contact Us</span>
      </div>
    </a>

    <!-- Side Panel for Email Form -->
    <SidePanel
      :visible="isPanelVisible"
      title="Email Customer Service"
      size="panel-md"
      @close="closePanel"
    >
      <RequestForm
        :user="user"
        :success="formSuccess"
        requestType="email"
        @submit="handleFormSubmission"
      />
    </SidePanel>
  </div>
</template>

<script>
import SidePanel from './SidePanel.vue';
import RequestForm from './contact_us/RequestForm.vue';

export default {
  name: 'ContactUsButton',
  components: {
    SidePanel,
    RequestForm,
  },
  data() {
    return {
      isPanelVisible: false,
      formSuccess: false,
    };
  },
  computed: {
    isAuthenticated() {
      return this.$userStore?.isAuthenticated || false;
    },
    // User data from store
    user() {
      const user = this.$userStore.user || {};
      return {
        name: this.$userStore.getFullName || '',
        email: user.email || '',
        phone: user.phone || '',
        company: user.company?.name || '',
      };
    },
  },
  methods: {
    showEmailForm() {
      this.isPanelVisible = true;
      this.formSuccess = false;
    },
    closePanel() {
      this.isPanelVisible = false;
      this.formSuccess = false;
    },
    handleFormSubmission(formData) {
      const endpoint = 'support-ticket/create';
      const successMessage = 'Message sent successfully';
      
      this.$postData(endpoint, formData).then((response) => {
        if (response.success) {
          this.$alertStore.pushSuccess(successMessage);
          this.formSuccess = true;
        } else if (response.message) {
          this.$alertStore.pushError(response.message);
        }
      });
    },
  },
}
</script>


<style scoped>
/* Floating Contact Us button */
.contact-us-button {
    position: fixed;
    right: 2rem;
    bottom: 1.25rem;
    z-index: 1050;
    background-color: var(--primary-500);
    color: var(--white);
    text-decoration: none;
    padding: 0.625rem 0.875rem;
    border-radius: var(--space-10);
    font-weight: 600;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

@media (min-width: 1200px) {
.contact-us-button:hover {
    color: #ffffff;
    background-color: var(--black);
}
}

/* Hide text on tablet & mobile; show only on desktop */
@media (max-width: 1199px) {
    .link-label {
        display: none;
    }

    .contact-us-button { 
      background-color: var(--white);
      right: 1rem;
      bottom: 1rem;
    }

    .fi-support {
      color:  var(--black);
    }
}
</style>